// Formatação e copy do requisito mínimo de turnover de D-1 (ENG-820).
// Compartilhado pela roletinha e pelo check-in: as duas telas dizem a MESMA
// coisa, e uma cópia por tela é uma frase que divergem.

/** Reais no formato brasileiro ("R$ 1.234,56"). */
export function formatTurnoverAmount(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(Number.isFinite(value) ? value : 0);
}

/**
 * Dia apurado como "07/09". Devolve null quando o core não mandou a data — a
 * copy então fala de "ontem" sem cravar um dia errado.
 *
 * Fatiado da string `Y-m-d` em vez de `new Date(...)`: um `Date` interpretaria
 * "2026-09-07" como meia-noite UTC e, no fuso de Brasília, imprimiria 06/09.
 */
export function formatTurnoverDay(day: string | null): string | null {
  if (!day) return null;

  const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);

  return parts ? `${parts[3]}/${parts[2]}` : null;
}
